import {
  REQUEST_ROUTES,
  RESPONSE_ROUTES,
  REQUEST_ROUTES_FAILURE,
  REQUEST_CREATE_ROUTE,
  RESPONSE_CREATE_ROUTE,
  REQUEST_CREATE_ROUTE_FAILURE,
  REQUEST_DELETE_ROUTE,
  RESPONSE_DELETE_ROUTE,
  REQUEST_DELETE_ROUTE_FAILURE,
  SEARCH_TERM_ROUTE_OPTIONS,
  ORDER_DEASC_ROUTE_OPTIONS,
  ON_SELECT_ROUTE,
  ON_UNSELECT_ROUTE,
} from "../actions/routesActions";

import { RESPONSE_CREATE_ROUTE_CONTROL_POINT, RESPONSE_DELETE_ROUTE_CONTROL_POINT } from "../actions/routeControlPointActions";

import {
  REQUEST_CREATE_TRIP,
  RESPONSE_CREATE_TRIP,
  REQUEST_CREATE_TRIP_FAILURE,
  REQUEST_DELETE_TRIP,
  RESPONSE_DELETE_TRIP,
  REQUEST_DELETE_TRIP_FAILURE,
  REQUEST_UPDATE_TRIP_CONTROL_POINTS,
  RESPONSE_UPDATE_TRIP_CONTROL_POINTS,
  REQUEST_UPDATE_TRIP_CONTROL_POINTS_FAILURE,
  ON_SELECT_TRIP,
  ON_UNSELECT_TRIP,
  REQUEST_CREATE_TRIP_UNIT,
  RESPONSE_CREATE_TRIP_UNIT,
  REQUEST_CREATE_TRIP_UNIT_FAILURE,
  REQUEST_DELETE_TRIP_UNIT,
  RESPONSE_DELETE_TRIP_UNIT,
  REQUEST_DELETE_TRIP_UNIT_FAILURE,
} from "../actions/tripsActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  routesDataState: queriesStates.NOT_REQUESTED,
  createRouteDataState: queriesStates.NOT_REQUESTED,
  deleteRouteDataState: queriesStates.NOT_REQUESTED,
  createRouteTripDataState: queriesStates.NOT_REQUESTED,
  deleteRouteTripDataState: queriesStates.NOT_REQUESTED,
  updateTripControlPoints: queriesStates.NOT_REQUESTED,
  createTripUnitDataState: queriesStates.NOT_REQUESTED,
  deleteTripUnitDataState: queriesStates.NOT_REQUESTED,
  routes: [],
  totalCount: 0,
  count: 0,
  selectedRouteId: null,
  selectedTripId: null,
  selectedTripUnitId: null,
  requestOptions: {
    page: 0,
    count: -1,
    orderDesc: false,
    searchTerm: "",
  },
  errors: [],
};

const routeReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ROUTES: {
      return Object.assign({}, state, {
        routesDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_ROUTES: {
      return Object.assign({}, state, {
        routesDataState: queriesStates.READY,
        routes: action.data.routes,
        totalCount: action.data.total,
        count: action.data.filterCount,
      });
    }
    case REQUEST_ROUTES_FAILURE: {
      return Object.assign({}, state, {
        routesDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_CREATE_ROUTE: {
      return Object.assign({}, state, {
        createRouteDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_CREATE_ROUTE: {
      return Object.assign({}, state, {
        createRouteDataState: queriesStates.READY,
        routes: [action.data].concat(state.routes),
      });
    }
    case REQUEST_CREATE_ROUTE_FAILURE: {
      return Object.assign({}, state, {
        createRouteDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_ROUTE: {
      return Object.assign({}, state, {
        deleteRouteDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_DELETE_ROUTE: {
      return Object.assign({}, state, {
        deleteRouteDataState: queriesStates.READY,
        routes: state.routes.filter((x) => {
          return x.id !== action.data.id;
        }),
      });
    }
    case REQUEST_DELETE_ROUTE_FAILURE: {
      return Object.assign({}, state, {
        deleteRouteDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case RESPONSE_CREATE_ROUTE_CONTROL_POINT: {
      return Object.assign({}, state, {
        routes: state.routes.map((route) => {
          if (route.id === action.data.route.id) {
            route.controlPoints = route.controlPoints.concat({
              ...action.data.controlPoint,
              number: action.data.number,
            });
          }
          return route;
        }),
      });
    }
    case RESPONSE_DELETE_ROUTE_CONTROL_POINT: {
      return Object.assign({}, state, {
        routes: state.routes.map((route) => {
          if (route.id === action.data.route.id) {
            route.controlPoints = route.controlPoints.filter((x) => {
              return x.id !== action.data.controlPoint.id;
            });
          }

          return route;
        }),
      });
    }

    case SEARCH_TERM_ROUTE_OPTIONS: {
      return Object.assign({}, state, {
        requestOptions: Object.assign({}, state.requestOptions, {
          searchTerm: action.data,
        }),
      });
    }
    case ORDER_DEASC_ROUTE_OPTIONS: {
      return Object.assign({}, state, {
        requestOptions: Object.assign({}, state.requestOptions, {
          orderDesc: action.data,
        }),
      });
    }

    case ON_SELECT_ROUTE: {
      return Object.assign({}, state, {
        selectedRouteId: action.data,
      });
    }
    case ON_UNSELECT_ROUTE: {
      return Object.assign({}, state, {
        selectedRouteId: null,
      });
    }

    case REQUEST_CREATE_TRIP: {
      return Object.assign({}, state, {
        createRouteTripDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_CREATE_TRIP: {
      return Object.assign({}, state, {
        createRouteTripDataState: queriesStates.READY,
        routes: state.routes.map((x) => {
          if (action.routeId === x.id) {
            if (action.data.dayOff === true) {
              x.dayOffTrips = x.dayOffTrips.concat(action.data);
            } else {
              x.workDayTrips = x.workDayTrips.concat(action.data);
            }
          }

          return x;
        }),
      });
    }
    case REQUEST_CREATE_TRIP_FAILURE: {
      return Object.assign({}, state, {
        createRouteTripDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_TRIP: {
      return Object.assign({}, state, {
        deleteRouteTripDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_DELETE_TRIP: {
      return Object.assign({}, state, {
        deleteRouteTripDataState: queriesStates.READY,
        selectedTripId: null,
        selectedTripUnitId: null,
        routes: state.routes.map((x) => {
          if (action.routeId === x.id) {
            x.dayOffTrips = x.dayOffTrips.filter((f) => {
              return f.id !== action.data.id;
            });

            x.workDayTrips = x.workDayTrips.filter((f) => {
              return f.id !== action.data.id;
            });
          }

          return x;
        }),
      });
    }
    case REQUEST_DELETE_TRIP_FAILURE: {
      return Object.assign({}, state, {
        deleteRouteTripDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_UPDATE_TRIP_CONTROL_POINTS: {
      return Object.assign({}, state, {
        updateTripControlPoints: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_UPDATE_TRIP_CONTROL_POINTS: {
      return Object.assign({}, state, {
        updateTripControlPoints: queriesStates.READY,
        routes: state.routes.map((x) => {
          if (action.routeId === x.id) {
            x.dayOffTrips = x.dayOffTrips.map((f) => {
              if (f.id === action.data.id) {
                return action.data;
              }

              return f;
            });

            x.workDayTrips = x.workDayTrips.map((f) => {
              if (f.id === action.data.id) {
                return action.data;
              }

              return f;
            });
          }

          return x;
        }),
      });
    }
    case REQUEST_UPDATE_TRIP_CONTROL_POINTS_FAILURE: {
      return Object.assign({}, state, {
        updateTripControlPoints: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case ON_SELECT_TRIP: {
      return Object.assign({}, state, {
        selectedTripId: action.data.id,
        selectedTripUnitId: action.data.unit !== null ? action.data.unit.id : null,
      });
    }
    case ON_UNSELECT_TRIP: {
      return Object.assign({}, state, {
        selectedTripId: null,
        selectedTripUnitId: null,
      });
    }

    case REQUEST_CREATE_TRIP_UNIT: {
      return Object.assign({}, state, {
        createTripUnitDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_CREATE_TRIP_UNIT: {
      return Object.assign({}, state, {
        createTripUnitDataState: queriesStates.READY,
        selectedTripUnitId: action.unit.id,
        routes: state.routes.map((x) => {
          if (action.routeId === x.id) {
            x.dayOffTrips = x.dayOffTrips.map((f) => {
              if (action.data.tripId === f.id) {
                f.unit = action.unit;
              }

              return f;
            });

            x.workDayTrips = x.workDayTrips.map((f) => {
              if (action.data.tripId === f.id) {
                f.unit = action.unit;
              }

              return f;
            });
          }

          return x;
        }),
      });
    }
    case REQUEST_CREATE_TRIP_UNIT_FAILURE: {
      return Object.assign({}, state, {
        createTripUnitDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_TRIP_UNIT: {
      return Object.assign({}, state, {
        deleteTripUnitDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_DELETE_TRIP_UNIT: {
      return Object.assign({}, state, {
        deleteTripUnitDataState: queriesStates.READY,
        selectedTripUnitId: null,
        routes: state.routes.map((x) => {
          if (action.routeId === x.id) {
            x.dayOffTrips = x.dayOffTrips.map((f) => {
              if (action.data.tripId === f.id) {
                f.unit = null;
              }

              return f;
            });

            x.workDayTrips = x.workDayTrips.map((f) => {
              if (action.data.tripId === f.id) {
                f.unit = null;
              }

              return f;
            });
          }

          return x;
        }),
      });
    }
    case REQUEST_DELETE_TRIP_UNIT_FAILURE: {
      return Object.assign({}, state, {
        deleteTripUnitDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    default:
      return state;
  }
};

export default routeReducer;
